import { Plus, CreditCard, Phone } from "lucide-react";
import { BrandButton } from "@/components/PageHeader";
import { SetupSection } from "./BasicsSection";
import { HotelEditor } from "./HotelEditor";
import { SortableList } from "./SortableList";
import { shortId } from "@/lib/api";

const MODES = [
  ["booking", CreditCard, "Book through the portal", "Participants pick a hotel, room type and nights during registration; the cost is added to their payment."],
  ["display", Phone, "Display only", "Hotels are listed with contact details; participants call the hotel and book themselves."],
];

export const AccommodationSection = ({ mode, hotels, set }) => {
  const update = (id, h) => set({ hotels: hotels.map((x) => (x.id === id ? h : x)) });
  const add = () => set({ hotels: [...hotels, { id: shortId(), name: "", kind: "Hotel", phone: "", location: "", facilities: [], drive_minutes: 0, hidden: false, rooms: [{ id: shortId(), name: "Standard Room", rate: 0, quantity: 10, hidden: false }] }] });
  return (
    <SetupSection id="accommodation" step="05" title="Accommodation" description="Add hotels near the venue and choose whether participants book through the portal this year.">
      <div className="grid sm:grid-cols-2 gap-3 mb-6">
        {MODES.map(([k, Icon, title, desc]) => (
          <button type="button" key={k} onClick={() => set({ accommodation_mode: k })} data-testid={`setup-accommodation-mode-${k}`}
            className={`text-left rounded-lg border-2 p-4 transition-colors ${mode === k ? "border-[#E60000] bg-[#FFF0F0]" : "border-[#E5E7EB] hover:border-gray-400"}`}>
            <div className="flex items-center gap-2 font-semibold"><Icon className="w-4 h-4 text-[#E60000]" />{title}</div>
            <p className="text-xs text-gray-600 mt-1">{desc}</p>
          </button>
        ))}
      </div>
      <div data-testid="setup-hotels-list">
        <SortableList items={hotels} onChange={(v) => set({ hotels: v })} testId="hotel-move" className="space-y-4" render={(h, i, controls) => <HotelEditor hotel={h} idx={i} booking={mode === "booking"} controls={controls} onChange={(v) => update(h.id, v)} onRemove={() => set({ hotels: hotels.filter((x) => x.id !== h.id) })} />} />
        {!hotels.length && <div className="rounded-lg border-2 border-dashed border-gray-300 p-8 text-center text-sm text-gray-500">No accommodation added for this event yet.</div>}
      </div>
      <BrandButton type="button" variant="outline" className="mt-4" onClick={add} data-testid="setup-hotel-add"><Plus className="w-4 h-4" />Add accommodation</BrandButton>
    </SetupSection>
  );
};
